
<template>
    <modal :show.sync=show :hide-footer="true"    
     :style="{ maxWidth: '90%', margin: '1.75rem auto' }">
        <b-row>
            <b-col cols="6" class="text-left">
                <button class="close-button" @click="closeModal">&times;</button>
            </b-col>
            <b-col cols="6" class="text-right">
                <el-button type="text" @click="downloadPDF()">
                    <i class="fa fa-download"></i>
                    <small class="ml-2 font-weight-bold">Download PDF</small>
                </el-button>
            </b-col>
        </b-row>
        <div id="consent-preview-content">
          <div v-if="platform === 'CBM' || platform === 'CBM_TR'" id="consent-cbm">
           <!-- <div
              v-if="(!_gAuth.isAppSas()) || (_gAuth.isAppSas() && platform === 'CBM')"
              id="consent-cbm"
            > -->
            <p>To:</p>
            <p>
                <strong>{{company_entity_name}}<br>
                Fintos Venture Group Sdn. Bhd. (1366615P/ 202001010295) <br>
                and its Subsidiaries Companies, including Techapp Business Sdn Bhd (“Company”) & <br>
                Credit Bureau Malaysia Sdn Bhd (“Credit Bureau Malaysia”); <br>
                CTOS Data Systems Sdn. Bhd.</strong>
            </p>
            <br>
            <div>
                <ol type="i">
                    <p>I/We hereby agree and grant consent to the (“Company”) and its authorized officers to:</p>
                    <br>
                    <li>conduct any credit, property, litigation, trade, CCRIS, identity, background, compliance risk and/or any other checks and verifications which are relevant to my/our business relationship/credit facility with the Company on me/our company, its directors/ shareholders/ owners/ partners/ guarantors/ individuals/ party/ providing securities with Credit Bureau Malaysia and/or any registered credit reporting agencies under Credit Reporting Agencies (CRA) Act 2010 at any time, for as long as such business relationship/credit facility continues to exist and/or where any dues owed to the Company remain unpaid and outstanding;</li>
                    <li>disclose my/our information including trade/account conduct to Credit Bureau Malaysia and/or any registered credit reporting agencies.</li>
                    <br>
                    <p>I/we also hereby grant consent to Credit Bureau Malaysia / CTOS Data Systems Sdn. Bhd. & any other relevant registered credit reporting agencies under the CRA Act 2010 to:</p>
                    <br>
                    <li> Procure my/our CCRIS and any other credit information from relevant data sources;</li>
                    <li> Assess, use and disclose credit information relating to me/our company (including its directors/its shareholders/owners/ partners/ guarantors/ individuals/ party providing securities to the Company) to Credit Bureau Malaysia, to the Company, other subscribers of Credit Bureau Malaysia and other persons/parties as and when the services of the credit reporting agency/ies is/are used for purposes mentioned above and for other purposes to the extent permitted by the applicable laws, regulations and/or regulatory requirements;</li>
                    <li> Share any of trade information/ account conduct as mentioned in clause (II) above to other subscribers of their services;</li>
                    <li class="no-break"> Transfer and disclose any credit information relating to me/our company, its directors/ its shareholders/ owners/ partners/ guarantors/ individuals/ party/ providing securities to relevant third parties and/or data processor either located within or outside Malaysia (including your Head Office). I/We hereby give consent to disclose my/our credit information except CCRIS, to such locations outside Malaysia.</li>
                    <br>
                    <p>I/We agree that:</p>
                    <br>
                    <li> Consent wherever mentioned in this letter is irrevocable and shall continue to be valid to the extent it remains consistent with any changes in law and for as long as there is an existing business relationship/ credit facility/ any dues remain outstanding with the Company;</li>
                    <li> The database of Credit Bureau Malaysia & the relevant registered credit reporting agency/ies may retain credit and trade information relating to me/us as long as it is consistent with applicable laws, regulations, regulatory requirements and any changes thereto;</li>
                    <li> Credit Bureau Malaysia & the relevant credit reporting agency/ies, its respective directors, officers, members, servants or agents are absolved and held harmless from all liability however arising from the abovementioned consent, the exercise of any/all activity stated above by Credit Bureau Malaysia & the relevant credit reporting agency/ies and the subsequent disclosure of any information relating to me/us for the purposes mentioned above.</li>
                </ol>
            </div>
            <div>
                <p>Date: ____________________</p>
                <div>Authorized Signatory of Applicant Name: ____________________</div>
                <div>Name: ____________________</div>
                <div>NRIC No.: ____________________</div>
                <div>Designation: ____________________</div>
            </div>
        </div>
           <br></br>
            <div v-if="platform === 'CBM_TR' || platform === 'CTOS'" id="consent-ctos" :style="platform === 'CBM' ? 'page-break-before: always;' : ''">
              <!-- <div
                  v-if="(_gAuth.isAppSas() && (platform === 'CBM' || platform === 'CTOS'))"
                  id="consent-ctos"
                  :style="platform === 'CBM' ? 'page-break-before: always;' : ''"
                > -->
                 <p>To:</p>
            <!-- <p>
                <strong>{{company_entity_name}}<br>
                Fintos Venture Group Sdn. Bhd. (1366615P/ 202001010295) <br>
                and its Subsidiaries Companies, including Techapp Business Sdn Bhd (“Company”) & <br>
                Credit Bureau Malaysia Sdn Bhd (“Credit Bureau Malaysia”); <br>
                CTOS Data Systems Sdn. Bhd.</strong>
            </p> -->
            <p>
              Techapp Business Sdn Bhd (1366615P/ 202001010295) <strong>("Company")</strong> &<br>
              CTOS Data Systems Sdn. Bhd. <strong>("CTOS")</strong>
            </p>
            <br>
            <div>
                <ol type="i">
                    <p>I/We hereby agree and grant consent to the Company and its authorized officers to:</p>
                    <br>
                    <!-- <li>conduct any credit, property, litigation, trade, CCRIS, identity, background, compliance risk and/or any other checks and verifications which are relevant to my/our business relationship/credit facility with the Company on me/our company, its directors/ shareholders/ owners/ partners/ guarantors/ individuals/ party/ providing securities with Credit Bureau Malaysia and/or any registered credit reporting agencies under Credit Reporting Agencies (CRA) Act 2010 at any time, for as long as such business relationship/credit facility continues to exist and/or where any dues owed to the Company remain unpaid and outstanding;</li> -->
                    <!-- <li>disclose my/our information including trade/account conduct to Credit Bureau Malaysia and/or any registered credit reporting agencies.</li> -->
                    <li>conduct any credit, property, litigation, trade, CCRIS, identity, background, compliance risk and/or any other checks and verifications which are relevant to my/our business relationship/credit facility with the Company on me/our company, its directors/ shareholders/ owners/ partners/ guarantors/ individuals/ party/ providing securities with CTOS and/or any registered credit reporting agencies under Credit Reporting Agencies (CRA) Act 2010 at any time, for as long as such business relationship/credit facility continues to exist and/or where any dues owed to the Company remain unpaid and outstanding;</li>
                    <li>disclose my/our information including trade/account conduct to CTOS and/or any registered credit reporting agencies.</li>
                    <br>
                    <!-- <p>I/we also hereby grant consent to Credit Bureau Malaysia / CTOS Data Systems Sdn. Bhd. & any other relevant registered credit reporting agencies under the CRA Act 2010 to:</p> -->
                    <p>I/we also hereby grant consent to CTOS & any other relevant registered credit reporting agencies under the CRA Act 2010 to:</p>
                    <br>
                    <li> Procure my/our CCRIS and any other credit information from relevant data sources;</li>
                    <!-- <li> Assess, use and disclose credit information relating to me/our company (including its directors/its shareholders/owners/ partners/ guarantors/ individuals/ party providing securities to the Company) to Credit Bureau Malaysia, to the Company, other subscribers of Credit Bureau Malaysia and other persons/parties as and when the services of the credit reporting agency/ies is/are used for purposes mentioned above and for other purposes to the extent permitted by the applicable laws, regulations and/or regulatory requirements;</li> -->
                    <li> Assess, use and disclose credit information relating to me/our company (including its directors/its shareholders/owners/ partners/ guarantors/ individuals/ party providing securities to the Company) to CTOS, to the Company, other subscribers of CTOS and other persons/parties as and when the services of the credit reporting agency/ies is/are used for purposes mentioned above and for other purposes to the extent permitted by the applicable laws, regulations and/or regulatory requirements;</li>
                    <li> Share any of trade information/ account conduct as mentioned in clause (II) above to other subscribers of their services;</li>
                    <li> Transfer and disclose any credit information relating to me/our company, its directors/ its shareholders/ owners/ partners/ guarantors/ individuals/ party/ providing securities to relevant third parties and/or data processor either located within or outside Malaysia (including your Head Office). I/We hereby give consent to disclose my/our credit information except CCRIS, to such locations outside Malaysia.</li>
                    <br>
                    <p>I/We agree that:</p>
                    <br>
                    <li> Consent wherever mentioned in this letter is irrevocable and shall continue to be valid to the extent it remains consistent with any changes in law and for as long as there is an existing business relationship/ credit facility/ any dues remain outstanding with the Company;</li>
                    <!-- <li> The database of Credit Bureau Malaysia & the relevant registered credit reporting agency/ies may retain credit and trade information relating to me/us as long as it is consistent with applicable laws, regulations, regulatory requirements and any changes thereto;</li> -->
                    <li> The database of CTOS & the relevant registered credit reporting agency/ies may retain credit and trade information relating to me/us as long as it is consistent with applicable laws, regulations, regulatory requirements and any changes thereto;</li>
                    <!-- <li> Credit Bureau Malaysia & the relevant credit reporting agency/ies, its respective directors, officers, members, servants or agents are absolved and held harmless from all liability however arising from the abovementioned consent, the exercise of any/all activity stated above by Credit Bureau Malaysia & the relevant credit reporting agency/ies and the subsequent disclosure of any information relating to me/us for the purposes mentioned above.</li> -->
                    <li> CTOS & the relevant credit reporting agency/ies, its respective directors, officers, members, servants or agents are absolved and held harmless from all liability however arising from the abovementioned consent, the exercise of any/all activity stated above by CTOS & the relevant credit reporting agency/ies and the subsequent disclosure of any information relating to me/us for the purposes mentioned above.</li>

                </ol>
            </div>
            <!-- Signature Rectangle -->
            <div style="margin: 32px 0 16px 0;">
                <div style="width: 300px; height: 80px; border: 2px solid #333; border-radius: 6px; margin-bottom: 8px;">
                    <!-- <span style="display: block; text-align: center; color: #888; line-height: 80px;">Signature</span> -->
                </div>
            </div>
            <div>
                <p>Date: ____________________</p>
                <div>Authorized Signatory of Applicant Name: ____________________</div>
                <div>Name: ____________________</div>
                <div>NRIC No.: ____________________</div>
                <div>Designation: ____________________</div>
            </div>
              </div>

        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal"
import html2pdf from 'html2pdf.js';
import { Image, Button, Select, Option } from 'element-ui'
export default {
  props: {
    show_preview: Boolean,
    company_entity_name : String,
    platform: {
      type: String,
      default: ''
    }
  },
  components: {
      Modal,
      [Button.name]: Button,
  },
  computed: {
    show: {
          get() {
              return this.show_preview
          },
          set(newVal) {
              this.$emit('update:show_preview', newVal)
          },
      },
  },
  data() {
      return {}
  },
  methods: {
    closeModal() {
    this.show = false;
  },
  // downloadPDF() {
  //   const element = document.getElementById("consent-preview-content");
  //   const timestamp = new Date().toISOString().replace(/[-:.]/g, "_"); // Format timestamp
  //   const filename = `consent_preview_${timestamp}.pdf`;
  //     const opt = {
  //       margin: 1,
  //       filename: filename,
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
  //       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] } // Add pagebreak option
  //     };
      
  //     html2pdf()
  //       .from(element)
  //       .set(opt)
  //       .save();
  //   }
downloadPDF() {
  const contentToExport = document.createElement('div');

  if (this.platform === 'CBM') {
    const cbmSection = document.getElementById('consent-cbm');
    
    if (!cbmSection) {
      console.error('CBM consent element not found in DOM');
      return;
    }

    contentToExport.appendChild(cbmSection.cloneNode(true));
  } else if (this.platform === 'CTOS') {
    const ctosSection = document.getElementById('consent-ctos');
    
    if (!ctosSection) {
      console.error('CTOS consent element not found in DOM');
      return;
    }

    contentToExport.appendChild(ctosSection.cloneNode(true));
  } else if (this.platform === 'CBM_TR') {
    // For CBM_TR, include both CBM and CTOS sections with proper page breaks
    const cbmSection = document.getElementById('consent-cbm');
    const ctosSection = document.getElementById('consent-ctos');
    
    if (!cbmSection || !ctosSection) {
      console.error('CBM_TR: Required elements not found in DOM', {
        cbm: !!cbmSection,
        ctos: !!ctosSection
      });
      return;
    }

    // Clone sections
    const cbmClone = cbmSection.cloneNode(true);
    const ctosClone = ctosSection.cloneNode(true);
    
    // Apply page break style directly to CTOS section
    ctosClone.style.pageBreakBefore = 'always';
    ctosClone.style.breakBefore = 'page';
    
    // Add both sections
    contentToExport.appendChild(cbmClone);
    contentToExport.appendChild(ctosClone);
  } else {
    return;
  }

  document.body.appendChild(contentToExport);

  const timestamp = new Date().toISOString().replace(/[-:.]/g, "_");
  const filename = `consent_preview_${timestamp}.pdf`;

  const opt = {
    margin: 1,
    filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    pagebreak: { 
      mode: ['css', 'legacy'],
      avoid: '.no-break'
    }
  };

  html2pdf()
    .from(contentToExport)
    .set(opt)
    .save()
    .then(() => {
      document.body.removeChild(contentToExport);
    })
    .catch((error) => {
      console.error('PDF generation failed:', error);
      document.body.removeChild(contentToExport);
    });
}
  }
};
</script>
<style scoped>
.close-button {
top: 10px;
right: 10px; 
background-color: transparent;
border: none;
font-size: 24px; 
color: #333; 
cursor: pointer;
outline: none;
padding: 0;
transition: color 0.3s ease;
}
.close-button:hover {
color: red; 
}
p {
    margin: 0; 
    padding: 0; 
    text-align: left; 
}

li {
    margin-left: 40px; 
    text-align: left; 
}

ol {
    padding-left: 20px; /* Optional: add padding to the left of the ordered list */
}

.html2pdf__page-break {
  page-break-before: always;
  break-before: page; /* For modern browsers */
}

/* Prevent page breaks inside important list items */
.no-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

/* Additional styling for better PDF rendering */
@media print {
  li {
    orphans: 3;
    widows: 3;
  }
  
  .no-break {
    page-break-inside: avoid;
    break-inside: avoid-page;
  }
}
</style>
